import React from 'react';
import { searchTerms } from '../../../constants';
import { CustomInput } from '@lwt-helix/controls';
import { useSearchStore } from '../../../store/store';
import { useLocation } from 'react-router-dom';

const ShowAdditionalInfo = () => {
    const location = useLocation();
    const {
        shouldShowAdditionalInfo,
        setToggleShouldShowAdditionalInfo,
        isFooterDisabled,
    } = useSearchStore(state => {
        const { [state.selectedModule]: moduleState } = state;
        const { breakdowns } = moduleState;
        const { selectedBreakdownTab, tabsByRoute } = breakdowns;
        const breakdownTabData = tabsByRoute[location.pathname]?.[selectedBreakdownTab];
        return ({
            shouldShowAdditionalInfo: breakdownTabData?.shouldShowAdditionalInfo,
            setToggleShouldShowAdditionalInfo: state.setToggleShouldShowAdditionalInfo,
            isFooterDisabled : breakdownTabData?.isFooterDisabled,
        });
    });

    return (
        <div className='ml-auto d-flex justify-content-center align-items-center'>
            <p className='mb-0 mr-2 clickable font-weight-normal font-gray-primary'
                onClick={() => setToggleShouldShowAdditionalInfo(location.pathname)}>
                {searchTerms.additionalInfo}
            </p>
            <CustomInput
                dataLwtId='additional-info-toggle'
                type='switch'
                id='additional-info-toggle'
                onChange={() => setToggleShouldShowAdditionalInfo(location.pathname)}
                checked={shouldShowAdditionalInfo}
                disabled={isFooterDisabled}
            />
        </div>
    )
};

export default ShowAdditionalInfo;
